import { ref } from 'vue'
import { defineStore } from 'pinia'
import { ECountry } from '@/shared/enum/country.enum'
import { EEnvironment } from '@/shared/enum/enviroment.enum'

export const useAppStore = defineStore('app', () => {
  const country = ref<ECountry>(ECountry.GT)
  const enviroment = ref<EEnvironment>(EEnvironment.PROD)
  const isLoading = ref<boolean>(false)

  const setCountry = (_country: ECountry) => {
    country.value = _country
  }

  const setLoading = (_loading: boolean) => {
    isLoading.value = _loading
  }

  const setEnviroment = (_enviroment: EEnvironment) => {
    enviroment.value = _enviroment
  }

  return {
    country,
    enviroment,
    isLoading,
    setCountry,
    setLoading,
    setEnviroment
  }
})
